<template>
  <div style="height: 100%;">
    <div class="download" style="background-color: #fff;">
      <img src="../../../static/di.png">
      <div class="textBox">
        <div style="width: 13px;left: -15px;top: -5px;position: absolute;">
          <img src="../../../static/laba.png">
        </div>
        <transition name="slide">
          <p class="text" :key="text.id">{{text.val}}</p>
        </transition>
      </div>
      <div class="erwm">
        <img style="width:100%" src="../../../static/erwm.png">
      </div>
    </div>
  </div>
</template>

<script>
import { } from '../../api';
export default {
  name: 'template',
  data() {
    return {
      textArr: [
        '豌**维正在咨询',
        'v***r正在咨询',
        '百****构正在咨询',
        '优**合正在咨询',
        '才**脑正在咨询',
        '童**美正在咨询',
        '乐**育正在咨询',
        '新***育正在咨询',
        '学***优正在咨询',
        '编*猫正在咨询',
        '美*****1正在咨询',
      ],
      number: 0
    }
  },
  computed: {
    text() {
      return {
        id: this.number,
        val: this.textArr[this.number]
      }
    }
  },
  mounted() {
    this.startMove()
  },
  methods: {
    startMove() {
      // eslint-disable-next-line
      let timer = setTimeout(() => {
        if (this.number === 2) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        this.startMove();
      }, 10000); // 滚动不需要停顿则将2000改成动画持续时间
    }
  },
}
</script>

<style>
.download {
  position: absolute;
}
.download img {
  width: 100%;
  display: block;
  margin: 0 auto;
  padding: 0;
  border: none;
}
.erwm {
  width: 2.3rem;
  height: 2.3rem;
  position: absolute;
  left: 2.5rem;
  bottom: 10px;
}
.textBox {
  width: 50%;
  height: 20px;
  margin-left: 10%;
  position: absolute;
  text-align: left;
  top: 21%;
  font-size: 12px;
  color: #fff;
}
.text {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s linear;
}
.slide-enter {
  transform: translateY(20px) scale(1);
  opacity: 1;
}
.slide-leave-to {
  transform: translateY(-20px) scale(0.8);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/servics/index.vue